import React, {useEffect, useState} from "react";
import {LoginService, ProfileService} from "../services/UserServices";

export const AuthContext = React.createContext();

export default function AuthProvider({children}) {
   const [isLoading, setLoading] = useState(true); // loader app
   const [isLogin, setLogin] = useState(false); // estado de la sesión
   const [userData, setData] = useState({}); // datos de la sesión iniciada

   useEffect(() => {
      verifyLoginStatus();
   }, []); // sola cuando se monta el componente

   useEffect(() => {
      if (userData && isLogin) {
         // si ya hay sesión y datos de usuario quita el loading
         setLoading(false);
      }
   }, [userData, isLogin]);

   const verifyLoginStatus = () => {
      // si hay un token iniciar sesión
      const token = localStorage.getItem("domecq_token");
      // console.log(typeof token, token);
      if (token) {
         return getUserdata(token);
      }
      setLoading(false);
      // si no ha token perdir que inicien sesión
   };

   const doLogin = (email, pwd) => {
      const data = {email, pwd};
      setLoading(true);
      LoginService(data)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            console.log(resp);
            if (status === "error") throw new Error("Error con los datos de sesión");
            if (data === "The user is not confirmed") {
               setLoading(false);
               return console.log("Por favor valida tu cuenta");
            }
            localStorage.setItem("domecq_token", data.token);
            getUserdata(data.token);
         })
         .catch((e) => {
            console.error("login", e);
            setLoading(false);
         });
   };

   const doLogout = () => {
      setLoading(true);
      setLogin(false);
      setData({});
      setLoading(false);
      localStorage.removeItem("domecq_token");
   };

   const getUserdata = (token) => {
      ProfileService()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error("Error al recuperar información de usuario");

            setData(data[0]);
            setLogin(true);
         })
         .catch((e) => {
            console.error(e);
            doLogout();
         });
   };

   return <AuthContext.Provider value={{isLoading, isLogin, userData, doLogin, doLogout, getUserdata}}>{children}</AuthContext.Provider>;
}
